import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Modal, Spin } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import liracrypt from "../Liracrypt/liracrypt";
import { LoadingOutlined } from "@ant-design/icons";

function SessionError({ visible }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const [spinState, setSpinState] = useState(false);
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  return (
    <>
      <Modal
        closable={false}
        open={visible}
        centered={true}
        onOk={() => {
          setSpinState(true);
          liracrypt.logout(history, dispatch);
        }}
        okText={
          <h5
            style={{
              margin: 0,
              color: "#fff",
              fontWeight: "600",
              marginTop: "-7px",
              fontSize: "1rem",
            }}
          >
            {spinState ? (
              <Spin indicator={antIcon} style={{ color: "#fff" }} />
            ) : (
              "Sign In"
            )}
          </h5>
        }
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{
          style: { marginBottom: "10px", width: "120px", padding: "0.5rem" },
        }}
      >
        <h6
          style={{
            margin: 0,
            color: "#fff",
            fontWeight: 600,
            fontSize: "1rem",
          }}
        >
          <div
            className="d-flex align-items-center"
            style={{ display: "flex", alignItems: "center" }}
          >
            <span
              className="d-flex"
              style={{ marginRight: "10px", display: "flex" }}
            >
              <ExclamationCircleOutlined
                style={{ color: "#ffc107", fontSize: "24px" }}
              />
            </span>
            <span className="d-flex" style={{ display: "flex" }}>
              Session Expired ! .Please Login Again.
            </span>
          </div>
        </h6>
      </Modal>
    </>
  );
}

export default SessionError;
